<template>
	<div class="ASN componetself" v-loading="PLoad">
		<div class="body_btns headbtn">
			<vxe-button type="text" class="tool-btn _icon_button" title="新增" @click="ADDDetail" v-if="!IsCGY">
				<i class="iconfont icon-AddwithcircleF iconSize "></i>新增
			</vxe-button>
			<!-- <vxe-button type="text" class="tool-btn _icon_button" title="修改" @click="OpenDetailTab('update')">
				<i class="iconfont icon-update iconSize "></i>修改
			</vxe-button> -->
			<!-- <vxe-button type="text" class="tool-btn _icon_button" title="批量删除">
				<i class="iconfont icon-shanchu iconSize "></i>批量删除
			</vxe-button> -->
			<vxe-button type="text" class="tool-btn _icon_button" title="查看详情" @click="GetASNDeatil"
				:loading="ASNdetailload" :disabled="ASNdetailload">
				<i class="iconfont icon-detail-fill iconSize "></i>查看详情
			</vxe-button>
			<vxe-button type="text" class="tool-btn _icon_button" title="导出" 
				@click="exportData" 
				:loading="exportload" :disabled="exportload">
				<i class="iconfont icon-export iconSize "></i>导出
			</vxe-button>
		</div>
		<!-- ASN 发运单 -->
		<div class="componet_header">
			<div class="filter">
				<template v-for="(item,index) in  filterList">
					<div class="filter_item" :key="index">
						<c-filter :item="item" 
							:form="filterForm" :line="true" :textMini="45" :VailShow="filterShow"></c-filter>
					</div>
				</template>
			</div>
			<div class="btns">
				<el-button type="primary" class="pursh_mainBtn" :loading="selectLog" :disabled="selectLog" @click="selectOrder">查询</el-button>
			</div>
		</div>
		<div class="componet_body">
			<div class="body_content">
				<!-- checkbox -->
				<c-table ref="ctablemain" :table="table" :coltype="'seq'"
					@FitColumns="table.head=$event" @listenToChild="listenToChild"></c-table>
				
			</div>
		</div>
	</div>
</template>

<script>
	import {filterData,tablehead} from './asnList.js';
	export default{
		props:{
			pageId: {
				type: String,
				default:''
			},
		},
		data(){
			return{
				filterForm:{},
				table: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
					_height: undefined
				},
				selectLog:false,
				ASNdetailload:false,
				exportload:false,
				checkOne:{},
				PLoad: false,
                filterList:[]
			}
		},
		computed:{
			//filterList(){
			//	return filterData;
			//},
			userinfo() {
				return this.$store.getters.UserInfo;
			},
			IsCGY(){
				return this.userinfo.accountType=='cgy'
			},
		},
		methods:{
			listenToChild(e){
				if(e&&e.rowClick) this.checkOne=e.rowClick;
				else if(e&&e.rowdbClick){
					this.checkOne=e.rowdbClick;
					this.GetASNDeatil();
				}
			},
			selectOrder(){
				try{
					if(this.selectLog) return;
					this.selectLog=true;
					this.$BH().base.http({
						url:'Web/GetASNList',
						data:{
							filterList:this.filterList,
							filterForm:this.filterForm,
							FUser:this.userinfo.pfnumber,
							gysFUser:this.userinfo.fnumber,
							FType:this.userinfo.accountType,
							pageId:this.pageId
						},
						success:(res)=>{
							let {data,head}=res.data.value;
							this.table.data=data;
							this.checkOne={};
							if(data.length>0)
								this.$refs.ctablemain?.updateCoulm();
						},
						loadingcontrol:()=>{
							this.selectLog=false;
						}
					})
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
					this.selectLog=false;
				}
			},
			//新增新的单据
			ADDDetail(){
				try{
					console.log(this.userinfo)
					this.$tab.openSpecTab('送货单明细页面_新增','asnDetail',{
						order:{
							head:[{
								_id:0,
								_status:0
							}],
							body:[]
						},
						isadd:true,
						pageId:this.pageId
					});
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
				}
			},
			//查看ASN详情
			GetASNDeatil(){
				try{
					if(!this.checkOne||JSON.stringify(this.checkOne)=='{}')
						throw '请先选中行';
					this.$tab.openSpecTab('送货单明细页面_修改','asnDetail',{
						checkOne:this.checkOne,
						isadd:false,
						pageId:this.pageId
					});
				}catch(e){
					//TODO handle the exception
					this.$BH().message(e);
				}
			},
			//导出数据
			exportData(){
				try{
					if(this.exportload) return;
					this.exportload=true;
					//梳理数据的
					this.exportDataReq(this.table,()=>{
						this.exportload=false;
					});
				}catch(e){
					this.$BH().message(e);
					this.exportload=false;
				}
			},
			exportDataReq(table,callback){
				let {head,data}=table;
				let headarr=[];
				head.map(item=>{
					if(!item.hide){
						headarr.push({
							name:item.name,
							title:(item.title||item.name)
						});
					}
				});
				this.$BH().base.http({
					url:'Web/EXPORTDATATOEXCEL',
					data:{
						head:headarr,
						data:data
					},
					success:(res)=>{
						let {value}=res.data;
						let basestr = res.data.value;
						if (basestr == '') {
							this.$BH().message('返回数据错误');
							callback&&callback();
						} else
							this.$BH().DownLoadBase64({
								data: {
									name: '到货计划'+new Date().format('yyyyMMddhhmmss'),
									base64Str: basestr
								},
								loadingcontrol: () => {
									this.exportload = false;
									this.operate = false;
								}
							});
					},
					loadingcontrol:callback				
				})
			},
            PageInit() {
                try {
                    this.PLoad = true;
                    this.$BH().base.http({
                        url: 'Web/GetASNList_INIT',
                        data: {
                            FUser: this.userinfo.pfnumber,
                            gysFUser: this.userinfo.fnumber,
                            FType: this.userinfo.accountType,
							pageId:this.pageId
                        },
                        success: (res) => {
                            // console.log(res)
                            let { value } = res.data;
							this.filterList = value.filterList || []//(value.filterList || []).filter(item => !item['allowUser'] || item['allowUser'].split(',').findIndex(jitem => jitem == this.userinfo.accountType)>-1);
                            this.table.head = (value.head || []).filter(item => !item['allowUser'] || item['allowUser'].split(',').findIndex(jitem => jitem == this.userinfo.accountType)>-1);
                        },
                        loadingcontrol: () => {
                            this.PLoad = false;
                        }
                    })
                } catch (e) {
                    this.$BH().message(e);
                    this.PLoad = false;

                }
			},
			filterShow(filterItem) {
				if (filterItem.allowUser) {
					let users = (filterItem.allowUser || '').split(',');
                    let Index = users.findIndex(item => item == this.userinfo.accountType)
					return Index > -1;
				}
				// return true;
				return !filterItem['hide'] ;
            }
		},
		mounted() {
			setTimeout(()=>{
				this.$refs.ctablemain?.updateCoulm();
			},0);
		},
		created() {
			//this.table.head=tablehead;
			this.PageInit();
		}
	}
</script>

<style>
</style>